import "core-js/modules/es.array.concat";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.match";
import "core-js/modules/es.string.search";
import _objectSpread from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _typeof from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/typeof";
import _classCallCheck from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/createSuper";
import Protocol from './protocol';
import { invokeWin, off } from './lib/tenvideo';
import { buildUrl, buildParams, isPlainObject } from './util';

var _version = navigator.userAgent.match(/(?:QQLive)\/(\d+)/);

var _protocalVersion = navigator.userAgent.match(/(?:QQLive)\/(?:\d+)\/(\d+)/);

var version = _version && _version[1];
var protocalVersion = _protocalVersion && _protocalVersion[1];
/**
 * PC 客户端 JSBridge
 * @class PCJSBridge
 * @extends {Protocol}
 */

var PCJSBridge = /*#__PURE__*/function (_Protocol) {
  _inherits(PCJSBridge, _Protocol);

  var _super = _createSuper(PCJSBridge);

  function PCJSBridge() {
    _classCallCheck(this, PCJSBridge);

    return _super.apply(this, arguments);
  }

  _createClass(PCJSBridge, [{
    key: "invoke",

    /**
     * 提供给新增加的 api，直接调用的方式
     */
    value: function invoke() {
      return invokeWin.apply(this, arguments);
    }
  }, {
    key: "openLogin",
    value: function openLogin() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (location.search.match(/(cid|vid|pid)=[a-z0-9]+/)) {
        params.parent = 'player';
      }

      return this.invoke('login', params);
    }
    /**
     * 退出登录，若未登录情况下，将不会触发
     * @returns {Promise}
     * @example
     * atom.logout()
     */

  }, {
    key: "logout",
    value: function logout() {
      return this.invoke('logout');
    }
  }, {
    key: "openUrl",
    value: function openUrl(url) {
      var ie = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var protocol = location.protocol.match(/^https?:/) ? location.protocol : 'https:';

      if (url.match(/^\/\//)) {
        // 补全地址
        url = protocol + url;
      }

      window.open(url);
    }
  }, {
    key: "getAppInfo",
    value: function getAppInfo() {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        resolve(_this2.invoke('GetProtocalVersion').then(function (res) {
          return {
            'deviceType': 'windows',
            'version': res,
            'screenResolution': "".concat(window.screen.availWidth, "*").concat(window.screen.availHeight)
          };
        }));
      });
    }
  }, {
    key: "getMainUserInfo",
    value: function getMainUserInfo() {
      var _this3 = this;

      return new Promise(function (resolve, reject) {
        _this3.invoke('GetMyData').then(function (res) {
          try {
            if (res) {
              res = JSON.parse(res);

              if (res.main_login === 'wx') {
                resolve({
                  'headurl': res.wx_head,
                  'nick': res.wx_nick,
                  'appid': res.appid,
                  'openid': res.openid,
                  'VipLevel': res.VipLevel,
                  'HollywoodType': res.HollywoodType,
                  'main_login': res.main_login,
                  'type': res.main_login,
                  'access_token': res.access_token
                });
              } else if (res.main_login === 'qq') {
                resolve({
                  'headurl': res.QQPortraitUrl40,
                  'id': res.Uin,
                  'nick': res.Name,
                  'sex': res.Gender,
                  'main_login': res.main_login,
                  'VipLevel': res.VipLevel,
                  'HollywoodType': res.HollywoodType,
                  'type': res.main_login,
                  'appid': res.vqq_appid,
                  'openid': res.vqq_openid,
                  'access_token': res.vqq_access_token
                });
              }
            }

            resolve(null);
          } finally {
            resolve(null);
          }
        });
      });
    }
    /**
     * 切换账号登录
     * @returns {Promise}
     * @example
     * atom.switchLogin()
     */

  }, {
    key: "switchLogin",
    value: function switchLogin(type) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (isPlainObject(type)) {
        params = type;
      }

      if (location.search.match(/(cid|vid|pid)=[a-z0-9]+/)) {
        params.parent = 'player';
      }

      return this.invoke('switchAccount', params);
    }
  }, {
    key: "play",
    value: function play(cid, vid) {
      var param = {
        cid: cid,
        vid: vid
      };

      if (Object.prototype.toString.call(cid) === '[object Object]' && (cid.cid || cid.vid)) {
        param = cid;
      }

      return this.invoke('OpenQQLive', "qqlive://sso/cid=".concat(param.cid, "&vid=").concat(param.vid));
    }
    /**
     * 发送消息给客户端和窗口页面
     * @param  {String} event 消息的事件名称
     * @param  {Object} args  消息的参数
     * @param  {Boolean} noself  不发送给自己的窗口页面，默认false发给自己，通常不使用此参数，在回调里通过isself区分来源
     */

  }, {
    key: "postMessage",
    value: function postMessage(event, args, noself) {
      var _this4 = this;

      args = _typeof(args) === 'object' ? JSON.stringify(args) : '{}';
      setTimeout(function () {
        // 自己给自己发消息时同步发取不到登录状态，延时异步一下
        _this4.invoke('NotifyObservers', event, args, !!noself);
      }, 350);
    }
  }, {
    key: "getVersion",
    value: function getVersion() {
      return version;
    }
  }, {
    key: "getProtocalVersion",
    value: function getProtocalVersion() {
      return protocalVersion;
    }
    /**
     * 拉登陆右侧二维码支持开通&购买
     * @param param {Object}主要是aid
     * @param parent {String}用于客户端定位浮层位置 'main' || 'player'
     */

  }, {
    key: "loginQQLiveWithPay",
    value: function loginQQLiveWithPay(param, parent) {
      var _parent = parent || 'player';

      var url = '';

      if (protocalVersion >= 50150915) {
        url = 'https://film.qq.com/wx/wx_login_cli_v2.html';
      } else {
        url = 'https://film.qq.com/wx/wx_login_cli.html';
      }

      url = buildUrl(url, param);
      return this.invoke('OpenQQLive', 'qqlive://sso/login=1&withpay=1&parent=' + _parent + '&withpayurl=' + encodeURIComponent(url));
    }
    /**
     * 打开minipay浮层窗口（IE）
     * @param param {Object} - minipay不可以直接传aid参数，会导致aid拼接异常
     * 目前bp_minipay处理的参数如下
     * @param [param.cid] {String} - 视频资源的cid
     * @param [param._cid] {String} - 视频资源的cid
     * @param [param.vid] {String} - 视频资源的vid
     * @param [param._vid] {String} - 视频资源的vid
     * @param [param._pid] {String} - 视频资源的pid(直播)
     * @param [param.amount] {String} - 开通月份
     * @param [param.aid_version] {String} - aid版本 目前都传的V0
     * @param [param._channel] {String} - aid中的参数 目前都传的0
     * @param [param._platform] {String} - aid中的平台号 客户端默认2000
     * @param [param._version] {String} - aid中的版本号
     * @param [param._source] {String} - aid中的一级来源
     * @param [param._source2] {String} - 很久不传了
     * @param [param._typeid] {String} - 很久不传了
     * @param [param._listid] {String} - 很久不传了
     * @param [param._scene] {String} - aid中的一级（标识通过扫码或其他途径）
     * @param [param.tab] {String} - 决定minipay打开时展示的tab是vip || svip
     * @param [param.actid] {String} - 透传活动号
     * @param [param._actid] {String} - 透传活动号
     * @param [param.ntype] {String} - 是否定位在连续包月 serial
     * @param parent {String}用于客户端定位浮层位置 'main' || 'player'
     */

  }, {
    key: "openMinipay",
    value: function openMinipay(param, parent) {
      var url = buildUrl('https://cache.tv.qq.com/bigportal/film/pay/bp_minipay.html', param);

      var _parent = parent || 'main';

      return this.invoke('OpenQQLive', 'qqlive://sso/' + 'parent=' + _parent + '&minipayurl=' + encodeURIComponent(url));
    }
    /**
     * 打开单片付费浮层窗口（IE）
     * @param param {Object}
     * 目前bp_paycenter处理的参数如下
     * @param [param.aid] {String} - 根据特定规则拼接的 aid 字符串，用于平台、版本号等，目前单点未做处理
     * @param [param.cid] {String} - 视频资源的cid
     * @param [param.type] {String} - 单片付费类型 [0: 点播/视频付费，1: 直播付费, 2: 购买道具]
     * @param [param.goplay] {String} - 取了之后没有使用
     * @param [param.pageid] {String} - 电视剧补差价pageid 已经好久不传
     * @param [param.pay_diff_tag] {String} - 电视剧补差价支付类型标记 已经好久不传
     * @param [param.sandbox] {String} - 传1进入测试环境
     * @param parent {String}用于客户端定位浮层位置 'main' || 'player'
     */

  }, {
    key: "openSinglePay",
    value: function openSinglePay(param, parent) {
      var url = buildUrl('https://cache.tv.qq.com/bigportal/film/pay/bp_paycenter.html', param);

      var _parent = parent || 'main';

      return this.invoke('OpenQQLive', 'qqlive://sso/' + 'parent=' + _parent + '&minipayurl=' + encodeURIComponent(url));
    }
    /**
     * 打开会员业务相关浮层 一般用于播放器界面 主界面不要用
     * @param url {String}
     * @param urlParam {Object}
     * @param parent {String} 'main' || 'player'
     */

  }, {
    key: "openVipPaymask",
    value: function openVipPaymask(url, urlParam, parent) {
      var _parent = parent || 'player';

      var _url = buildUrl(url, urlParam);

      return this.invoke('OpenQQLive', 'qqliveex://openVipPaymask/parent=' + _parent + '&vippaymaskurl=' + encodeURIComponent(_url));
    }
    /**
     * 打开通用浮层
     * @param  {String} url      页面地址
     * @param  {Number} width    对话框宽度
     * @param  {Number} height   对话框高度
     * @param  {String} title    对话框标题，默认为“腾讯视频”
     * @param  {Boolean} domodal 是否为模态阻塞窗口
     */

  }, {
    key: "openMask",
    value: function openMask(url, urlParam, width, height, title, domodal) {
      var _title = title || '腾讯视频';

      var _domodal = domodal ? 1 : 0;

      var _url = buildUrl(url, urlParam);

      var _width = width || 500;

      var _height = height || 500;

      return this.invoke('HintBrowseDlg', encodeURIComponent(_url), _width, _height, encodeURIComponent(_title), _domodal);
    }
    /**
     * 打开会员支付相关浮层
     * @param param {Object} sourceType = openvip || opensvip || wxsinglepay
     * @param parent {String} 'main' || 'player'
     */

  }, {
    key: "loginWithWeChatPay",
    value: function loginWithWeChatPay(param, parent) {
      var _parent = parent || 'main';

      if (!param.sourceType) {
        param.sourceType = 'openvip';
      }

      var url = buildUrl('//cache.tv.qq.com/win/vip/paymask.html', param);
      return this.invoke('OpenQQLive', 'qqlive://sso/login=1&withwechatpay=1&parent=' + _parent + '&withwechatpayurl=' + encodeURIComponent(url));
    }
    /**
     * 移除事件存储对象中的callback函数 PC客户端移除事件监听的唯一方式
     * @param event
     * @param callback
     */

  }, {
    key: "removeCallback",
    value: function removeCallback(event) {
      var handler = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      off(event, handler);
    }
    /**
     * 参数等同于openMinipay
     * @param {*} _config
     * @param {*} _parent
     */

  }, {
    key: "openVip",
    value: function openVip(_config, _parent) {
      try {
        var _this = this;

        var parent = _parent || 'main';
        var config = _config.wxConfig || _config.qqConfig || _config;
        if (_config.wxConfig || _config.qqConfig) console.warn('新版本不需要区分微信和QQ的传参 统一拉起minipay');
        if (!config) console.error('不传开通浮层参数会导致aid流水错误');
        config = config || {};
        config._version = version;
        config.aid_version = 'V0';
        this.getMainUserInfo().then(function (logInfo) {
          // 已登录
          if (logInfo && logInfo.main_login) {
            // 新版全部拉起minipay 老版本只有QQ拉起minipay
            if (protocalVersion > 50190815 || logInfo.main_login === 'qq') {
              _this.openMinipay(config, parent);
            } else {
              config.source = config.source || config._source;
              config.sourceType = config.sourceType || "open".concat(config.tab).toLowerCase();

              _this.loginWithWeChatPay(config, parent);
            }
          } else {
            // 未登录
            _this.loginQQLiveWithPay({
              aid: "V0$$2:2000$4:".concat(config.source || config._source, "$11:2$3:").concat(version)
            }, parent);
          }
        });
      } catch (e) {
        console.error(e);
      }
    }
    /**
     * 打开由中间弹出的浮层窗口
     * @param {String} url - 页面地址
     * @param {Number} options.width - 窗口宽度
     * @param {Number} options.height - 窗口高度
     * @example
     * atom.openModalWindow('https://film.qq.com/minipay/', {
     *   width: 860,
     *   height: 600
     * })
     */

  }, {
    key: "openModalWindow",
    value: function openModalWindow(url) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (options.browser) {
        return this.invoke('OpenQQLive', url);
      }

      if (!options.width) {
        options.width = 760;
      }

      if (!options.height) {
        options.height = 500;
      }

      if (!options.title) {
        options.title = ' ';
      }

      return this.openView("qqlive://openhintbrowsedlg/".concat(buildParams(_objectSpread({
        hintbrowseurl: url
      }, options), true)));
    }
    /**
     * native 页面跳转操作
     * @param {string} url - qqlive://sso/vbarid= 协议地址
     * @example <caption>PC 客户端示例：打开播放器</caption>
     * atom.openView('qqlive://sso/vbarid=gfxf78u0fv5ydba')
     */

  }, {
    key: "openView",
    value: function openView() {
      var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return this.invoke('OpenQQLive', url);
    }
  }, {
    key: "close",
    value: function close() {
      window.external.Close();
    }
  }]);

  return PCJSBridge;
}(Protocol);

export default new PCJSBridge();